module.exports = __webpack_public_path__ + "static/media/ButtonIcon.a6eae6d6.svg";